"use client";

import { Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function FindYourSpiritualHome() {
  return <section data-section-id="92915" id="the-movement" className="dark bg-black text-white relative z-10 -mt-[5vw] [clip-path:polygon(0_5vw,100%_0,100%_100%,0_100%)] bg-gradient-to-b from-black to-[#0a0a0a]">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-[calc(5vw+8rem)] pb-32">
        <div className="mx-auto max-w-3xl text-center flex flex-col items-center">
          <h2 className="font-serif text-4xl md:text-[48px] font-normal mb-6 text-white tracking-tight">
            Follow us on social for updates.
          </h2>
          <p className="font-sans font-normal text-xl md:text-2xl text-[#CCCCCC] mb-12">Join the movement and stay connected with Skin N' Bonez Chicago for the latest tour dates and exclusive rock 'n' roll content.</p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-6 w-full sm:w-auto">
            <Button asChild size="lg" className="bg-primary text-white hover:bg-primary/90 w-full sm:w-auto text-base h-14 px-8 rounded-[4px] shadow-[0_0_20px_rgba(255,0,0,0.3)] transition-all duration-300">
              <Link to="https://www.instagram.com/skinnbonezchicago/" newTab>
                <Search className="mr-2 size-5" />
                Follow Us
              </Link>
            </Button>
            <Button asChild size="lg" variant="outline" className="bg-transparent border-2 border-white text-white hover:bg-primary hover:border-primary w-full sm:w-auto text-base h-14 px-8 rounded-[4px] transition-all duration-300">
              <Link to="https://www.facebook.com/share/1AQfq21VC3/?mibextid=wwXIfr" newTab>
                Join The Club
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}